import React from 'react';
import  Router  from './routes/index.js';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import materialTheme from './theme/materialTheme.js';
import V3Theme from './V3/themes/V3Theme.js';
import { ParcelProvider } from './contexts/ParcelContext.js';
import { UserProvider } from './contexts/UserContext.js';
import { ConsumerProvider } from './contexts/ConsumerContext.js';
import ErrorBoundary from './pages/ErrorBoundary.js';

const VERSION = process.env.REACT_APP_VERSION || 'v3';
const currentTheme = VERSION === 'v3' ? V3Theme : materialTheme;

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={currentTheme}>
        <UserProvider>
          <ParcelProvider>
            <ConsumerProvider>
              <RouterProvider router={ Router } />
            </ConsumerProvider>
          </ParcelProvider>
        </UserProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
